import detailsImage from './details_image.png';

type DetailsHeaderProps = {
  siteName: string;
};

function DetailsHeader({ siteName }: DetailsHeaderProps) {
  return (
    <div className="flex flex-row items-center gap-4 bg-gray-100 px-4 py-8">
      <div className="flex-wrap">
        <img src={detailsImage} className="size-16" />
      </div>
      <label className="whitespace-pre-line font-bold">{siteName}</label>
    </div>
  );
}

export default DetailsHeader;
